/* eslint-disable react/prop-types */
/**
 * Month field for the Standard link. Shows the pick as "November 2026"
 * (never the browser's "November ----"), and opens a grid of months with
 * arrows on either side of the year to move between years.
 *
 * value / onChange use "YYYY-MM", like a native month input.
 */
import {
  Button,
  IconButton,
  Popover,
  TextField,
  Typography
} from '@material-ui/core'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import React, { useState } from 'react'

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export const formatMonth = (value) => {
  if (!value) return ''
  const [year, month] = value.split('-').map(Number)
  return `${MONTHS[month - 1]} ${year}`
}

const MonthPicker = ({ id, label, value, onChange, disabled }) => {
  const [anchor, setAnchor] = useState(null)
  const today = new Date()
  const [pickedYear, pickedMonth] = value
    ? value.split('-').map(Number)
    : [null, null]
  const [year, setYear] = useState(pickedYear || today.getFullYear())

  const openPicker = (event) => {
    if (disabled) return
    setYear(pickedYear || today.getFullYear())
    setAnchor(event.currentTarget)
  }

  const pick = (monthIndex) => {
    onChange(`${year}-${String(monthIndex + 1).padStart(2, '0')}`)
    setAnchor(null)
  }

  return (
    <>
      <TextField
        id={id}
        label={label}
        value={formatMonth(value)}
        placeholder="Pick a month"
        onClick={openPicker}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            openPicker(event)
          }
        }}
        variant="outlined"
        size="small"
        fullWidth
        margin="dense"
        disabled={disabled}
        InputLabelProps={{ shrink: true }}
        inputProps={{ readOnly: true, style: { cursor: 'pointer' } }}
      />
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div style={{ padding: 8, width: 260 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <IconButton
              size="small"
              aria-label="Previous year"
              onClick={() => setYear((y) => y - 1)}
            >
              <ChevronLeft />
            </IconButton>
            <Typography variant="subtitle1" data-testid="month-picker-year">
              {year}
            </Typography>
            <IconButton
              size="small"
              aria-label="Next year"
              onClick={() => setYear((y) => y + 1)}
            >
              <ChevronRight />
            </IconButton>
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 4,
              marginTop: 4
            }}
          >
            {MONTHS.map((name, index) => {
              const selected = year === pickedYear && index + 1 === pickedMonth
              return (
                <Button
                  key={name}
                  size="small"
                  color="primary"
                  variant={selected ? 'contained' : 'text'}
                  onClick={() => pick(index)}
                >
                  {name.slice(0, 3)}
                </Button>
              )
            })}
          </div>
        </div>
      </Popover>
    </>
  )
}

export { MonthPicker }
